import type { TypeLogState, TypeLogStore } from "./typeLogStore";

// ── Scalar selectors ─────────────────────────────────────────────────────────
export const selectSelectedWell = (s: TypeLogStore) => s.selectedWell;
export const selectPreviouslySelectedWells = (s: TypeLogStore) =>
  s.previouslySelectedWells;
export const selectUwidFormat = (s: TypeLogStore) => s.uwidFormat;

// ── Action selectors ─────────────────────────────────────────────────────────
export const selectSelectWell = (s: TypeLogStore) => s.selectWell;
export const selectSetUwidFormat = (s: TypeLogStore) => s.setUwidFormat;
export const selectReset = (s: TypeLogStore) => s.reset;

// ── Compound selectors ───────────────────────────────────────────────────────

/**
 * Full client-selection state (actions stripped). Returns a new object on
 * every call — consumers MUST use shallow equality:
 *
 *   import { useShallow } from "zustand/react/shallow";
 *   const state = useTypeLogStore(useShallow(selectTypeLogState));
 */
export const selectTypeLogState = (s: TypeLogStore): TypeLogState => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { selectWell, setUwidFormat, reset, ...state } = s;
  return state;
};
